export default __webpack_public_path__ + "static/media/logo_en.5af4876f.svg";